



import { useState } from "react";
import { Link } from "react-router-dom";
import portfolioData from "../../data/portfolioData";

export default function Portfolio() {
  const [filter, setFilter] = useState("All");

  // ✅ Filter buttons ke liye 6 categories
  const displayCategories = [
    "All",
    "Food & Restaurant",
    "Education",
    "Healthcare",
    "Retail & Shopping",
    "Real Estate & Construction"
  ];

  // ✅ FIX: Filter ke baad sirf top 6 items lene ke liye .slice(0, 6) lagaya hai
  const filteredItems = (
    filter === "All"
      ? portfolioData
      : portfolioData.filter((p) => p.category === filter)
  ).slice(0, 6);

  return (
    <section id="portfolio" className="portfolio" style={{ padding: "80px 0" }}>
      <div className="container">
        <header className="section-header">
          <h2>Our Portfolio</h2>
          <p>
            A showcase of projects that demonstrate our capabilities and
            commitment to excellence
          </p>
        </header>

        {/* Filter Buttons */}
        <div className="text-center mb-4" data-aos="fade-up">
          {displayCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`btn ${
                filter === cat ? "btn-primary" : "btn-outline-primary"
              } m-1`}
              style={{
                borderRadius: "25px",
                padding: "8px 24px",
                fontWeight: "600",
                transition: "all 0.3s ease",
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Portfolio Grid - Sirf 6 Cards Render Honge */}
        <div className="row gy-4">
          {filteredItems.map((item, index) => (
            <div
              className="col-lg-4 col-md-6"
              key={item.id}
              data-aos="fade-up"
              data-aos-delay={100 + index * 100}
            >
              <Link
                to={`/portfolio/${item.slug}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div
                  style={{
                    borderRadius: "10px",
                    overflow: "hidden",
                    boxShadow: "0 2px 15px rgba(0,0,0,0.08)",
                    height: "100%",
                    background: "#fff",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 15px rgba(0,0,0,0.08)";
                  }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="img-fluid"
                      style={{
                        width: "100%",
                        height: "220px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    />
                  </div>

                  <div style={{ padding: "20px" }}>
                    <span
                      className="badge"
                      style={{
                        background: "#e8f4fd",
                        color: "#0070f3",
                        marginBottom: "10px",
                        padding: "5px 14px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {item.category}
                    </span>
                    <h4
                      style={{
                        fontWeight: "700",
                        fontSize: "1.1rem",
                        marginBottom: "8px",
                      }}
                    >
                      {item.title}
                    </h4>
                    <p
                      style={{
                        color: "#666",
                        fontSize: "14px",
                        marginBottom: "10px",
                        lineHeight: "1.6",
                      }}
                    >
                      {item.desc}
                    </p>
                    <span
                      style={{
                        color: "#007bff",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      View Details <i className="bi bi-arrow-right ms-1" />
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-5" data-aos="fade-up">
          <Link
            to="/portfoliopage"
            className="btn"
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "14px 40px",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "15px",
              transition: "all 0.3s ease",
            }}
          >
            View All Industries <i className="bi bi-arrow-right ms-2" />
          </Link>
        </div>
      </div>
    </section>
  );
}